import { useQuery } from "@tanstack/react-query";
import { employersDictionaryService } from "../../services/dictionaries";

export const useEmployersDictionary = () => {
    return useQuery({
        queryKey: ["employers", "dictionary"],
        queryFn: (): Promise<string[]> => employersDictionaryService.getEmployersDictionary(),
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
    });
};
